/**
 * Convert string into upper snake case.
 * Join punctuation with underscore and convert letters into uppercase.
 * @memberof module:stringcase/lib
 * @function constcase
 * @param {string} str - String to convert.
 * @returns {string} Const cased string.
 */
'use strict';

var uppercase = require('./uppercase');

var snakecase = require('./snakecase');
/** @lends constcase */


function constcase(str) {
  if (constcase.isConstcase(str)) {
    return str;
  }

  return uppercase(snakecase(str));
}
/**
 * Checks whether the string are constcase.
 * @memberof module:stringcase/lib
 * @function constcase.isConstcase
 * @param {string} str - String to check.
 * @returns {boolean} - True if the string are constcase.
 */


constcase.isConstcase = function (str) {
  return str && /^[A-Z_]+$/.test(str);
};

module.exports = constcase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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